__turbopack_context__.v({
  "bgNature": "page-module__z6hFhW__bgNature",
  "bgOverlay": "page-module__z6hFhW__bgOverlay",
  "fadeIn": "page-module__z6hFhW__fadeIn",
  "page": "page-module__z6hFhW__page",
  "shake": "page-module__z6hFhW__shake",
});
